import React from "react";
import { connect } from "react-redux";
import { BaseDialog } from "../components/layout/Dialog";
import { showDialog } from "../actions/dialog";
import "./PayMeMoney";
import _ from "lodash";
import Logger from "../util/Logger";
import { NavigationUtils } from "../util/NavigationUtils";
import { GTM_CONVERSION_LABEL_ANNUAL_ELA } from "../constants";
import { ScreenRecorder } from "../util/ScreenRecorder";
import { TrackingAnalytics } from "../analytics/TrackingAnalytics";
import { accountApi } from "../api/AccountApi";
import { handleError } from "../util/Errors";

class PayMeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpgrade: null,
      pricingPlanHtml: "",
    };
  }

  renderPricingPlans = () => {
    return (
      <div className="col no-gutters">
        <div className="row no-gutters">
          <div className="col text-center">
            <h1 className="font-bold-title">UPGRADE</h1>
          </div>
          <i className="material-icons clickable" onClick={this.onDialogHidden}>
            close
          </i>
        </div>
        <div
          id="payment-upsell"
          style={{ textAlign: 'center', paddingTop: '30px' }}
        >
          <p>Certain POPin features require a license or an upgrade to use.</p>
          <p>
            We offer single creator or enterprise options.<br/>
            Click the Start My POPin Subscription button to learn more!
          </p>
          <br />
          <p>
            <a className="btn btn-primary"
              target="#subscription"
              href="https://www.trypopin.com/popin-subscription-options">
                Start My POPin Subscription
            </a>
          </p>
        </div>
      </div>
    );
  };

  onDialogHidden = () => {
    const { onHidden } = this.props;
    if (onHidden) {
      onHidden();
    }
  };

  onUpgradeHidden = () => {
    this.setState({ showUpgrade: null });
  };

  upgradePlan = (plan) => {
    accountApi
      .switchPlan(plan)
      .then(() => {
        this.onUpgradeHidden();
        window.location.reload();
      })
      .catch((err) => {
        Logger.error("Error upgrading to plan: ", plan, err);
        this.onUpgradeHidden();
        handleError(err, null);
      });
  };

  showPaymentUpgradeModal = (plan) => {
    this.setState({ showUpgrade: plan });
  };

  componentDidMount() {
    ScreenRecorder.trackCustomAction("BILLING_MODAL_SHOWN");

    const { openedFrom } = this.props;
    if (!!openedFrom) {
      TrackingAnalytics.gtag("Billing Modal Opened", {
        opened_from: openedFrom,
      });

      TrackingAnalytics.send("Upgrade Modal Opened", {
        click_source: openedFrom,
      });
    }

    const { user } = this.props;
    const component = this;
    const pricingCallback = {
      isFive() {
        // return RNJesus.isWorthy(user);
        return false;
      },

      getPricingPlan: function getPricingPlan() {
        return _.get(user, "plan.id");
      },

      onSecondButtonClicked: function onSecondButtonClicked(hasPricePlan) {
        Logger.info("Second button clicked: ", hasPricePlan);
        const planName = this.isFive()
          ? "premium_5_monthly"
          : "premium_monthly";
        NavigationUtils.routeToLegacy(`/billing?planName=${planName}`);
      },

      onThirdButtonClicked: function onThirdButtonClicked(hasPricePlan) {
        const plan = _.get(user, "plan.id");

        // If they are already premium, we should have their card info
        if (
          plan === "premium_monthly" ||
          plan === "premium_5_monthly" ||
          plan === "premium_with_support_monthly" ||
          plan === "premium_one_year"
        ) {
          component.showPaymentUpgradeModal("business_monthly");
        } else {
          Logger.info("Third button clicked: ", hasPricePlan);
          const planName = "business_monthly";
          NavigationUtils.routeToLegacy(`/billing?planName=${planName}`);
        }
      },

      onFourthButtonClicked: function onFourthButtonClicked(hasPricePlan) {
        Logger.info("Fourth button clicked: ", hasPricePlan);
        // routeWithPlan('annual_ela');
        window.gtag_report_conversion(GTM_CONVERSION_LABEL_ANNUAL_ELA);

        if (window.Intercom) {
          window.Intercom(
            "showNewMessage",
            "I`m interested in the Enterprise plan."
          );
        } else {
          window.location.href = "mailto:sales@popinnow.com";
        }
      },
    };

    window.popinPricing = pricingCallback;
  }

  componentWillUnmount() {
    window.popinPricing = null;
  }

  render() {
    const { showUpgrade } = this.state;
    return (
      <div>
        <BaseDialog
          customModalDialogClass="pricing-plan-dialog"
          show={true}
          body={this.renderPricingPlans()}
          hideDialog={this.onDialogHidden}
        />

        {!!showUpgrade && (
          <BaseDialog
            show={true}
            title="Upgrade to the Business plan?"
            body={
              <div>
                Your existing subscription will be automatically updated to
                reflect the change in price.
              </div>
            }
            hideDialog={this.onUpgradeHidden}
            cancel="Cancel"
            ok="Upgrade"
            onOk={() => this.upgradePlan(showUpgrade)}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const user = state.user.user;
  return {
    user: user,
  };
};

export default connect(mapStateToProps, {
  showDialog,
})(PayMeModal);
